export default __webpack_public_path__ + "static/media/playicon.6051722b.svg";